import { APP_INITIALIZER, Injector, Optional, Provider } from '@angular/core'
import { SERVER_REQUEST_ORIGIN } from '@spartacus/core'
import { ebI18nextInit } from './eb-i18next-init'

export const ebI18nextProviders: Provider[] = [
  {
    provide: APP_INITIALIZER,
    useFactory: ebI18nextInit,
    deps: [Injector, [new Optional(), SERVER_REQUEST_ORIGIN]],
    multi: true
  }
]
